import * as actionTypes from "./actionTypes";
import * as eventTypes from "../../../../../actions/eventTypes";
import initialState from "reducers/initialState";

export const documentApprovalLevelsReducer = (state = initialState.document.decision.approvalLevels, action) => {
  switch (action.type) {
    case actionTypes.LOAD_APPROVAL_LEVELS_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true
        }
      };
    }
    case actionTypes.LOAD_APPROVAL_LEVELS_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }

    case actionTypes.APPROVAL_LEVEL_UPDATED: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: false
        }
      };
    }

    case eventTypes.OFFER_DECISION_APPROVAL_LEVELS_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: {
          loading: false,
          loaded: false
        }
      };
    }

    case eventTypes.OFFER_ORCHESTRATOR_COMPETENCE_ORDER_EXECUTED: {
      return initialState.document.decision.approvalLevels;
    }

    default:
      return state;
  }
};

export const documentApprovalsHistoryReducer = (state = initialState.document.decision.approvalsHistory, action) => {
  switch (action.type) {
    case actionTypes.LOAD_APPROVALS_HISTORY_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true
        }
      };
    }
    case actionTypes.LOAD_APPROVALS_HISTORY_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }
    case actionTypes.APPROVALS_HISTORY_INVALIDATED: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: false
        }
      };
    }

    default:
      return state;
  }
};
export const approvalTypeDecisionReasonsReducer = (
  state = initialState.document.decision.approvalTypeDecisionReasons,
  action
) => {
  switch (action.type) {
    case actionTypes.LOAD_APPROVAL_TYPE_DECISION_REASONS_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true
        }
      };
    }
    case actionTypes.LOAD_APPROVAL_TYPE_DECISION_REASONS_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          decisionReasons: action.payload,
          loading: false,
          loaded: true
        }
      };
    }
    case actionTypes.LOAD_APPROVAL_TYPE_DECISION_REASONS_FAILED: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: false
        }
      };
    }

    default:
      return state;
  }
};
